<template>
  <div class="content">
    <h2 class="content_title">
      Editar senha
    </h2>
    <form class="row"
          novalidate
          @submit.prevent="editPassword()">
      <div class="col-12 col-md-9">
        <div class="row">
          <div class="col-12 col-sm-9 col-lg-8">
            <div v-if="(user !== null) && !user.primeiro_acesso && user.senha"
                 class="form-group">
              <label class="lbl-editarSenha"
                     for="senhaAtual">Senha atual</label>
              <input id="senhaAtual"
                     ref="senhaAtual"
                     v-model="senhaAtual"
                     v-validate="'required'"
                     autocomplete="off"
                     class="form-control form-control-sm"
                     :class="{ 'is-invalid': errors.has('senhaAtual') }"
                     data-vv-name="senhaAtual"
                     name="senhaAtual"
                     placeholder="* * * * * *"
                     required
                     type="password">
              <small v-if="errors.has('senhaAtual')"
                     class="invalid-feedback">
                {{ errors.first('senhaAtual') }}
              </small>
            </div>
          </div>

          <div class="col-12 col-sm-6">
            <div class="form-group">
              <label for="newPassword"
                     class="lbl-editarSenha">Nova senha</label>
              <input id="newPassword"
                     ref="novaSenha"
                     v-model="novaSenha"
                     v-validate="{ required: true }"
                     autocomplete="off"
                     data-vv-name="novaSenha"
                     class="form-control form-control-sm"
                     :class="{ 'is-invalid': errors.has('novaSenha') }"
                     name="novaSenha"
                     placeholder="* * * * * *"
                     required
                     type="password">
              <small v-if="errors.has('novaSenha')"
                     class="invalid-feedback">
                {{ errors.first('novaSenha') }}
              </small>
            </div>
          </div>

          <div class="col-12 col-sm-6">
            <div class="form-group">
              <label for="confirmNewPassword"
                     class="lbl-editarSenha">Confirmar nova senha</label>
              <input id="confirmNewPassword"
                     v-model="confirmarNovaSenha"
                     v-validate="{ confirmed: 'novaSenha', required: true }"
                     autocomplete="off"
                     class="form-control form-control-sm"
                     :class="{ 'is-invalid': errors.has('confirmarNovaSenha') }"
                     data-vv-rules="confirmed:novaSenha"
                     data-vv-name="confirmarNovaSenha"
                     data-vv-as="novaSenha"
                     name="confirmarNovaSenha"
                     placeholder="* * * * * *"
                     required
                     type="password">
              <small v-if="errors.has('confirmarNovaSenha')"
                     class="invalid-feedback">
                {{ errors.first('confirmarNovaSenha') }}
              </small>
            </div>
          </div>
        </div>

        <div class="row no-gutters justify-content-end">
          <div class="d-inline-block">
            <button id="btn-salvar"
                    class="btn btn-primary btn-sm"
                    type="submit">
              Salvar
            </button>
          </div>
        </div>
      </div>
    </form>

    <b-modal ref="modalCertificados"
             hide-footer
             title="Selecione um certificado"
             size="lg">
      <grid-certificados v-if="certificados && certificados.length > 0"
                         :certificados="certificados"
                         @onSelectCertificado="onSelectCertificado" />
    </b-modal>
  </div>
</template>

<script>
  /* services */
  import BryService from '@/services/Assinaturas/BryService'
  import AuthService from "@/services/Auth/AuthService"

  /* components */
  import GridCertificados from '@/components/GridCertificados'

  /* libraries */
  import { mapGetters } from 'vuex'

  /* constants */
  import objSwal from '@/constants/swalValues'

  export default {
    name: 'EditarSenha',
    components: {
      GridCertificados
    },
    data () {
      return {
        senhaAtual: '',
        novaSenha: '',
        confirmarNovaSenha: '',
        certificados: null,
        desafioGerado: null
      }
    },
    computed: {
      ...mapGetters({
        user: 'auth/getUser',
      }),
    },
    methods: {
      updatePassword () {
        loader({ text: 'Enviando dados de atualização...', active: true })

        return AuthService.editarSenha(this.senhaAtual, this.novaSenha).then(() => {
          objSwal.success.title = ''
          objSwal.success.text = 'Senha alterada com sucesso!'

          this.limparCampos()
          this.$validator.reset()

          return Swal.fire(objSwal.success)
        }).catch((e) => {
          this.limparCampos()

          if (e.response.status === 400) {
            objSwal.error.title = ''
            objSwal.error.text = 'Por favor, digite uma nova senha diferente da atual'

            return Swal.fire(objSwal.error)
          }

          objSwal.error.title = ''
          objSwal.error.text = 'Senha incorreta!'

          return Swal.fire(objSwal.error)
        })
      },
      limparCampos () {
        this.senhaAtual = ''
        this.novaSenha = ''
        this.confirmarNovaSenha = ''

        loader({ text: '', active: false })
      },
      // CERTIFICADO
      async checkCertificado () {
        loader({ text: 'Validando extensão...', active: true })

        if (!BryService.isExtensionInstalled()) {
          loader({ text: '', active: false })

          objSwal.info.title = 'Extensão não instalada'
          objSwal.info.text = 'A extensão para assinatura digital não está instalada no seu navegador. Deseja instalar agora?'
          objSwal.info.confirmButtonText = 'Instalar'
          objSwal.info.showCancelButton = true
          objSwal.info.cancelButtonText = 'Não'

          return Swal.fire(objSwal.info).then(({ value }) => {
            if (value) {
              try {
                BryService.getExtension()
              } catch (e) {
                this.onError(e.message)
              }
            }
          })
        }

        loader({ text: 'Obtendo certificados...', active: true })

        this.certificados = await BryService.getCertificates()

        loader({ text: '', active: false })

        if (this.certificados.length === 0) {
          return this.onLoginError('Erro', 'Não foi possível selecionar o certificado')
        }

        if (this.certificados.length > 1) {
          this.$refs.modalCertificados.show()
        } else {
          this.certificadoSelecionado = this.certificados[0]

          // Anulando certificados obtidos
          this.certificados = null

          this.autenticarCertificado()
        }
      },
      onSelectCertificado (certificado) {
        this.certificadoSelecionado = certificado
        // Fechando modal
        this.$refs.modalCertificados.hide()
        // Anulando certificados obtidos
        this.certificados = null
        // Autenticando o usuário
        this.autenticarCertificado()
      },
      async autenticarCertificado () {
        loader({ text: 'Autenticando via certificado digital...', active: true })

        try {
          this.desafioGerado = await BryService.makeChallenge()
        } catch (e) {
          loader({ text: '', active: false })
          return this.onError('Erro', 'Não foi possível gerar o token de autenticação')
        }

        BryService.signBase64Content(this.certificadoSelecionado.certId, BryService.prepareContentForSignature(this.desafioGerado.challenge))
          .then(async (signature) => {
            this.desafioCifrado = signature.assinaturas[0].hashes[0]

            loader({ text: 'Validando certificado digital...', active: true })

            AuthService.authenticateChallenge(this.desafioGerado.challenge, this.desafioCifrado, this.certificadoSelecionado.certificateData)
              .then(this.updatePassword).catch((error) => {
                this.onError('Erro', 'Não foi possível validar o certificado.')
              }).finally(() => {
                loader({ text: '', active: false })
              })
          }, ({ description, code }) => {
            this.onError(`Erro ${code}`, description)
          }).finally(() => {
            loader({ text: '', active: false })
          })
      },
      editPassword () {
        this.$validator.validateAll().then((res) => {
          if (!res) return
          this.checkCertificado()
          /*if (this.usuario && this.usuario.primeiro_acesso) {
          } else {
            this.apiSenha();
          }*/
        })
      },
      onSuccess (title = '', text) {
        objSwal.error.title = title
        objSwal.error.text = text

        loader({ text: '', active: false })
        return Swal.fire(objSwal.error).then(res => this.$router.push('/'))
      },
      onError (title = 'Erro', text) {
        objSwal.error.title = title
        objSwal.error.text = text

        loader({ text: '', active: false })
        return Swal.fire(objSwal.error).then(res => this.$router.push('/'))
      }
    },
  }
</script>

<style lang="scss">
  @import '../scss/_utilities/exports';

  .icon {
    &--blue {
      fill: $color-blue;
    }
  }
</style>
